// extracted by mini-css-extract-plugin
export default {"rating":"ny-z","numberOfStars":"oy-z","count":"py-z","barGraphSpacing":"qy-z","barGraph":"ry-z"};